export const API_V1_URI = "/api/v1";

export const ACCOUNT_API_LOGIN = API_V1_URI + "/accounts/login";
export const ACCOUNT_API_LOGIN_BY_QR = API_V1_URI + "/accounts/login_by_qr";
export const ACCOUNT_API_PROFILE = API_V1_URI + "/accounts/profile";
export const ACCOUNT_API_PASSWORD = API_V1_URI + "/accounts/update-password";
export const ACCOUNT_API_FORGOT_PASSWORD =
  API_V1_URI + "/accounts/forgot-password";
export const ACCOUNT_API_RESET_PASSWORD =
  API_V1_URI + "/accounts/reset-password";
export const ACCOUNT_API_REFRESH_TOKEN = API_V1_URI + "/accounts/refresh-token";
export const ACCOUNT_API_PERMISSION = API_V1_URI + "/accounts/permissions";

export const CURRENT_STAFF_API = API_V1_URI + "/current_staff";

export const USER_MANAGEMENT_API = API_V1_URI + "/user_managements";

export const ROLE_MANAGEMENT_API = API_V1_URI + "/role_managements";
export const ROLE_MANAGEMENT_API_PERMISSION =
  API_V1_URI + "/role_managements/permissions";

export const FILE_API = API_V1_URI + "/files";
export const UPLOAD_FILE_API = API_V1_URI + "/uploads";
export const UPLOAD_FILE_PDF_API = API_V1_URI + "/uploads/pdf";

export const SEARCH_USER_API = API_V1_URI + "/search_engine/identity/users";

export const STATIC_PAGE_API = API_V1_URI + "/static_pages";
export const STATIC_PAGE_API_SEARCH = STATIC_PAGE_API + "/search";

export const CONTACT_API = API_V1_URI + "/contacts";
export const CONTACT_API_SEARCH = CONTACT_API + "/search";
export const CONTACT_API_REMOVE = CONTACT_API + "/remove_list";

export const COUPON_API = API_V1_URI + "/coupons";
export const COUPON_API_SEARCH = COUPON_API + "/search";
export const COUPON_API_REMOVE = COUPON_API + "/remove_list";

export const BLOG_API = API_V1_URI + "/blogs";
export const BLOG_API_SEARCH = BLOG_API + "/search";
export const BLOG_API_REMOVE = BLOG_API + "/remove_list";
export const BLOG_API_SORT_LIST = BLOG_API + "/sort_list";
export const BLOG_API_SORT = BLOG_API + "/sort";

export const BLOG_CATEGORY_API = API_V1_URI + "/blog_categories";
export const BLOG_CATEGORY_API_SEARCH = BLOG_CATEGORY_API + "/search";
export const BLOG_CATEGORY_API_REMOVE = BLOG_CATEGORY_API + "/remove_list";

export const STAFF_API = API_V1_URI + "/staffs";
export const STAFF_API_SEARCH = STAFF_API + "/search";
export const STAFF_API_LIST = STAFF_API + "/list";

export const THEME_SETTING_API = API_V1_URI + "/theme_settings";
export const THEME_SETTING_API_SEARCH = THEME_SETTING_API + "/search";
export const THEME_SETTING_API_REMOVE = THEME_SETTING_API + "/remove_list";

export const MENU_SETTING_API = API_V1_URI + "/menu_settings";
export const MENU_SETTING_API_SEARCH = MENU_SETTING_API + "/search";
export const MENU_SETTING_API_REMOVE = MENU_SETTING_API + "/remove_list";

export const CUSTOMER_API = API_V1_URI + "/customers";
export const CUSTOMER_API_SEARCH = CUSTOMER_API + "/search";
export const CUSTOMER_API_REMOVE = CUSTOMER_API + "/remove_list";

export const NOTIFICATION_MANAGER_API = API_V1_URI + "/notification_managers";
export const NOTIFICATION_MANAGER_API_SEARCH =
  NOTIFICATION_MANAGER_API + "/search";
export const SEND_CG_NOTIFICATION_API =
  NOTIFICATION_MANAGER_API + "/customer_group/send_notification";
export const NOTIFICATION_MANAGER_API_REMOVE =
  NOTIFICATION_MANAGER_API + "/remove_list";

export const PRODUCT_CATEGORY_API = API_V1_URI + "/product_categories";
export const PRODUCT_CATEGORY_API_SEARCH = PRODUCT_CATEGORY_API + "/search";
export const PRODUCT_CATEGORY_API_REMOVE =
  PRODUCT_CATEGORY_API + "/remove_list";
export const PRODUCT_CATEGORY_API_SORT = PRODUCT_CATEGORY_API + "/sort_list";

export const PRODUCT_API = API_V1_URI + "/products";
export const PRODUCT_API_SEARCH = PRODUCT_API + "/search";
export const PRODUCT_API_SEARCH_LIST = PRODUCT_API + "/search_list";
export const PRODUCT_API_REMOVE = PRODUCT_API + "/remove_list";
export const PRODUCT_API_SORT = PRODUCT_API + "/sort_list";

export const SHIPPING_FEE_API = API_V1_URI + "/shipping_fee";
export const SHIPPING_FEE_API_DEFAULT = SHIPPING_FEE_API + "/default";
export const SHIPPING_FEE_API_BY_ADDRESS = SHIPPING_FEE_API + "/by_address";
export const SHIPPING_FEE_API_BY_ORDER_AMOUNT =
  SHIPPING_FEE_API + "/by_order_amount";

export const ADDRESS_API = API_V1_URI + "/addresses";
export const ADDRESS_API_COUNTRY = ADDRESS_API + "/countries";
export const ADDRESS_API_PROVINCE = ADDRESS_API + "/provinces";
export const ADDRESS_API_DISTRICT = ADDRESS_API + "/districts";
export const ADDRESS_API_WARD = ADDRESS_API + "/wards";

export const PRODUCT_COMMENT_API = API_V1_URI + "/product_comments";
export const COMMENT_API = API_V1_URI + "/comments";

export const ORDER_API = API_V1_URI + "/orders";
export const ORDER_API_SEARCH = ORDER_API + "/search";
export const ORDER_API_SEARCH_MY_ORDER = ORDER_API + "/search_my_order";
export const ORDER_API_EXPORT = ORDER_API + "/export_order";
export const ORDER_REPORT_API = API_V1_URI + "/order_reports";
export const ORDER_REPORT_API_TYPE = ORDER_REPORT_API + "/report_type";
export const ORDER_REPORT_API_STATISTICAL = ORDER_REPORT_API + "/statistical";
export const ORDER_API_CALCULATE_SHIPPING_FEE =
  ORDER_API + "/calculate_shipping_fee";
export const ORDER_API_APPLY_COUPON = ORDER_API + "/apply_coupon";

export const ORDER_PAYMENT_API = API_V1_URI + "/order_payments";

export const PRODUCT_ATTRIBUTE_GROUP_API =
  API_V1_URI + "/product_attribute_groups";
export const PRODUCT_ATTRIBUTE_GROUP_API_REMOVE =
  PRODUCT_ATTRIBUTE_GROUP_API + "/remove_list";
export const PRODUCT_ATTRIBUTE_API = API_V1_URI + "/product_attributes";
export const PRODUCT_ATTRIBUTE_API_REMOVE =
  PRODUCT_ATTRIBUTE_API + "/remove_list";
export const PRODUCT_ATTRIBUTE_VALUE_API =
  API_V1_URI + "/product_attribute_values";
export const PRODUCT_ATTRIBUTE_VALUE_API_REMOVE =
  PRODUCT_ATTRIBUTE_VALUE_API + "/remove_list";

export const TAG_API = API_V1_URI + "/tags";
export const TAG_API_REMOVE = TAG_API + "/remove_list";

export const CUSTOMER_GROUP_API = API_V1_URI + "/customer_groups";
export const CUSTOMER_GROUP_API_SEARCH = CUSTOMER_GROUP_API + "/search";
export const CUSTOMER_GROUP_API_REMOVE = CUSTOMER_GROUP_API + "/remove_list";

export const WEBSITE_CONFIGURATION_API = API_V1_URI + "/website_config";

export const APPLICATION_CONFIGURATION_API =
  API_V1_URI + "/application-configurations";
export const LANGUAGE_API = API_V1_URI + "/languages";

export const BRANCH_API = API_V1_URI + "/branches";
export const BRANCH_API_REMOVE = BRANCH_API + "/remove_list";
export const BRANCH_API_SORT = BRANCH_API + "/sort_list";
export const BRANCH_API_COPY_MENU = BRANCH_API + "/copy_menu";

export const SYSTEM_API = API_V1_URI + "/system_settings";
export const TIMEZONE_API = SYSTEM_API + "/time_zones";
export const GOOGLE_API = API_V1_URI + "/google_settings";
export const GOOGLE_FIREBASE_API = GOOGLE_API + "/firebase";

export const SALON_SERVICE_CATEGORY_API =
  API_V1_URI + "/salon_service_categories";
export const SALON_SERVICE_CATEGORY_API_REMOVE =
  SALON_SERVICE_CATEGORY_API + "/remove_list";
export const SALON_SERVICE_CATEGORY_API_SORT =
  SALON_SERVICE_CATEGORY_API + "/sort";

export const GALLERY_API = API_V1_URI + "/galleries";
export const GALLERY_API_SEARCH = GALLERY_API + "/search";
export const GALLERY_API_SORT = GALLERY_API + "/update_sort";
export const GALLERY_API_SORT_LIST = GALLERY_API + "/sorts";

export const SALON_SERVICE_API = API_V1_URI + "/salon_services";
export const SALON_SERVICE_API_SEARCH = SALON_SERVICE_API + "/search";
export const SALON_SERVICE_API_REMOVE = SALON_SERVICE_API + "/remove_list";
export const SALON_SERVICE_API_SORT = SALON_SERVICE_API + "/sort";

export const SALON_STAFF_API = API_V1_URI + "/salon_staffs";
export const SALON_STAFF_API_INIT_STAFF = SALON_STAFF_API + "/init_staff";
export const SALON_STAFF_API_SEARCH = SALON_STAFF_API + "/search";
export const SALON_STAFF_API_REMOVE = SALON_STAFF_API + "/remove_list";

export const APPOINTMENT_SETTING_API = API_V1_URI + "/appointment_settings";

export const BRANCH_GIFT_CARD_API = API_V1_URI + "/branch_giftcards";
export const BRANCH_GIFT_CARD_SEARCH_API = BRANCH_GIFT_CARD_API + "/search";

export const BRANCH_WEB_GIFT_CARD_API = API_V1_URI + "/branch_web_giftcards";
export const BRANCH_WEB_GIFT_CARD_SEARCH_API =
  BRANCH_WEB_GIFT_CARD_API + "/search";
export const BRANCH_WEB_GIFT_CARD_SEARCH_BY_ID_API =
  BRANCH_WEB_GIFT_CARD_API + "/search_by_id";
export const BRANCH_WEB_GIFT_CARD_STATUS_API =
  BRANCH_WEB_GIFT_CARD_API + "/update_status";
export const BRANCH_WEB_GIFT_CARD_USE_SERVICE_API =
  BRANCH_WEB_GIFT_CARD_API + "/update_use_service";
export const BRANCH_GIFT_CARD_SETTING_API =
  API_V1_URI + "/branch_giftcard_settings";

export const GIFT_CARD_COUPON_API = API_V1_URI + "/giftcard_coupons";
export const GIFT_CARD_COUPON_API_SEARCH = GIFT_CARD_COUPON_API + "/search";
export const GIFT_CARD_COUPON_API_REMOVE =
  GIFT_CARD_COUPON_API + "/remove_list";

export const BRANCH_GIFT_CARD_TEMPLATE_API =
  API_V1_URI + "/branch_giftcard_templates";
export const BRANCH_GIFT_CARD_TEMPLATE_API_SORT =
  BRANCH_GIFT_CARD_TEMPLATE_API + "/update_sort";
export const BRANCH_GIFT_CARD_TEMPLATE_API_SEARCH =
  BRANCH_GIFT_CARD_TEMPLATE_API + "/search";
export const BRANCH_GIFT_CARD_TEMPLATE_API_REMOVE =
  BRANCH_GIFT_CARD_TEMPLATE_API + "/remove_list";

export const BRANCH_GIFT_CARD_TEMPLATE_CATEGORY_API =
  API_V1_URI + "/branch_giftcard_template_categories";
export const BRANCH_GIFT_CARD_TEMPLATE_CATEGORY_API_SEARCH =
  BRANCH_GIFT_CARD_TEMPLATE_CATEGORY_API + "/search";
export const BRANCH_GIFT_CARD_TEMPLATE_CATEGORY_API_REMOVE =
  BRANCH_GIFT_CARD_TEMPLATE_CATEGORY_API + "/remove_list";

export const APPOINTMENT_API = API_V1_URI + "/appointments";
export const APPOINTMENT_API_SEARCH = APPOINTMENT_API + "/search";

export const UNIT_API = API_V1_URI + "/units";
export const UNIT_API_REMOVE = UNIT_API + "/remove_list";

export const THEME_TEMPLATE_API = API_V1_URI + "/theme_templates";
export const THEME_TEMPLATE_API_SEARCH = THEME_TEMPLATE_API + "/search";
export const THEME_TEMPLATE_API_REMOVE = THEME_TEMPLATE_API + "/remove_list";

export const SUPPLIER_API = API_V1_URI + "/suppliers";
export const SUPPLIER_API_REMOVE = SUPPLIER_API + "/remove_list";

export const PURCHASE_API = API_V1_URI + "/purchases";
export const PURCHASE_API_SEARCH = PURCHASE_API + "/search";

export const WARE_HOUSE_API = API_V1_URI + "/ware_houses";
export const WARE_HOUSE_API_REMOVE = WARE_HOUSE_API + "/remove_list";

export const ORDER_PACKING_LIST_API = API_V1_URI + "/order_packing_lists";

export const BILL_OF_LADING_API = ORDER_PACKING_LIST_API + "/bill_of_ladings";
export const BILL_OF_LADING_API_PICK_UP_ADDRESS =
  BILL_OF_LADING_API + "/pick_up_addresses";
export const BILL_OF_LADING_API_FEE = BILL_OF_LADING_API + "/fees";

export const TRANSPORTATION_API = API_V1_URI + "/transportations";

export const PAYMENT_GATEWAY_API = API_V1_URI + "/payment_gateways";
export const MODIFIER_GROUP_API = API_V1_URI + "/modifier_groups";

export const PROMOTION_CODE_API = API_V1_URI + "/promotion_codes";
export const PROMOTION_CODE_API_SEARCH = PROMOTION_CODE_API + "/search";

export const ORDER_PAYMENT_SETTING_API = API_V1_URI + "/order_payment_settings";
export const ORDER_PAYMENT_SETTING_API_COD = ORDER_PAYMENT_SETTING_API + "/cod";
export const ORDER_PAYMENT_SETTING_API_TRANSFER =
  ORDER_PAYMENT_SETTING_API + "/transfer";
